// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"fb2d9253","488":"a66faa4e"}[chunkId] + ".chunk.js";
};